import { shopPrefix } from '../../config';
import { SubscriptionManagementPageDataOut } from '../../store/api';
import { http } from '../axios';

const endpoint = `${shopPrefix}/v1/subscription-management/data`;

export interface SubscriptionParamTypes {
    page: number;
    pageSize: number;
    includeExpiredSubscriptions: boolean;
}
export const fetchManageSubscriptionData = async ({
    page,
    pageSize,
    includeExpiredSubscriptions
}: SubscriptionParamTypes): Promise<SubscriptionManagementPageDataOut> => {
    return http
        .get<SubscriptionManagementPageDataOut>(endpoint, {
            params: { page, pageSize, includeExpiredSubscriptions }
        })
        .then(response => response.data);
};
